import { styled, Typography } from '@ori-ui/mui';
import React from 'react';

import { maxWidth } from '../../constants';
import { useFooterContext, useTranslations } from '../../hooks';
import { MobileOfficeRoot } from '../MobileOffice';
import { SocialMediaIcon } from './SocialMediaIcon';

const MobileOfficeRootSection = MobileOfficeRoot.withComponent('section');

const Root = styled(MobileOfficeRootSection)(({ theme }) => ({
  maxWidth,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(6, 'auto', 8),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 6),
  },
}));

const Heading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const Icons = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
});

export const FollowUs: React.FC = () => {
  const { formatMessage } = useTranslations();
  const { data, isMobileOffice } = useFooterContext();

  return (
    <Root isMobileOffice={isMobileOffice}>
      <Heading variant="h6">{formatMessage('followUs')}</Heading>
      <Icons>
        {data?.socialMediaLinks.map((item, index) => (
          <a
            key={item.title ?? index}
            href={item.url ?? ''}
            title={item.title ?? ''}
          >
            <SocialMediaIcon icon={item.type} />
          </a>
        ))}
      </Icons>
    </Root>
  );
};
